import ReportSummaryPage from "./reportSummary";

export default ReportSummaryPage;